import { render, staticRenderFns } from "./partnerInvoicesTable.vue?vue&type=template&id=73da78e4&"
import script from "./partnerInvoicesTable.vue?vue&type=script&lang=ts&"
export * from "./partnerInvoicesTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports